<template>
    <div class="hotel">
        <div class="hotel-nrk">
            <div class="hotel-title-text" v-if="storeInfo.type==2">{{orderConfirm?'确认酒店':'发布询价酒店'}}</div>
            <div class="hotel-title-text" v-else>当前酒店</div>
            <ul class="hotel-item-list">
                <li v-for="item in orderConfirm?orderConfirmList:inquiryList" :key="item.id" class="hotel-item">
                    <div class="hotel-item-title">
                    {{item.title}}
                    </div>
                    <div class="hotel-item-star">
                        <div class="star-text">{{item.star | formatVar('HotelStar')}}</div>
                    </div>
                    <el-popconfirm
                        title="确定删除此报价酒店？"
                        @confirm="deleteHotel(item)"
                    >
                    <div class="joinTheinquiry" slot="reference" v-if="!orderConfirm">
                        <i class="el-icon-plus cross"></i>
                    </div>
                    </el-popconfirm>
                </li>
            </ul>
            <!--一家酒店时-业务人员-->
            <div class="business" v-if="showBusiness||orderConfirm&&storeInfo.type==2">
                <div>业务人员</div>
                <el-radio-group v-model="notifyAll" size="mini" @input="changeNotifyAll">
                    <el-radio-button label="1" v-if="!orderConfirm">通知全部</el-radio-button>
                    <el-radio-button label="2">销售人员</el-radio-button>
                </el-radio-group>
            </div>
            <!--一家酒店时-指定人员-->
            <ul class="business-list" v-if="notifyAll==2">
                <li v-for="item in PersonnelList" :key="item.id" @click="selectPerson(item)">
                    <i class="iconfont icon-weixin1 mr-2" :class="[ item.wechat_openid==''||item.uid==item.wechat_openid? 'text-muted' : 'text-success']"></i>
                    <span>{{item.truename}}</span>  
                    <el-button size="mini" :type="hasObjectExactMatch(appoint_uid,item)?'primary':''" class="personnel">{{hasObjectExactMatch(appoint_uid,item)?'已选':'选择'}}</el-button>
                </li>
            </ul>
        </div>
        <!--选择销售人员弹窗-->
        <el-dialog
        :visible.sync="confirmVisible"
        width="500px"
        center
        title="请选择确认销售"
        :close-on-click-modal="false"   
        :close-on-press-escape="false"
        :show-close="false"
        >
        <ul class="business-list" v-if="notifyAll==2">
            <li v-for="item in PersonnelList" :key="item.id" @click="selectPerson(item)">
                <i class="iconfont icon-weixin1 mr-2" :class="[ item.wechat_openid==''||item.uid==item.wechat_openid? 'text-muted' : 'text-success']"></i>
                <span>{{item.truename}}</span>  
                <el-button size="mini" :type="hasObjectExactMatch(appoint_uid,item)?'primary':''" class="personnel">{{hasObjectExactMatch(appoint_uid,item)?'已选':'选择'}}</el-button>
            </li>
        </ul>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="appoint_uid.length==0?true:false" type="primary" @click="confirmVisible=false">确 定</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapMutations,mapState,mapActions,mapGetters} from 'vuex'
export default {
  name: '',
  components: {},
  props: {
    //是否确认订单
    orderConfirm: {
      type: Boolean,
      default: false
    },
    //
     //确认订单酒店列表
     orderConfirmList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
        notifyAll:1,
        showBusiness: false,                 //显示业务人员
        //指定人员
        PersonnelList:[],                   //指定人员数组
        appoint_uid:[],                    //指定人员id数组
        //选择销售人员弹窗
        confirmVisible:false,
    };
  },
  computed: {
    ...mapGetters(['storeInfo']),
    ...mapState(['inquiryList','confirmid','userLoginMessage']),
  },
  watch: {
    //监听询价列表变化
    inquiryList: {
      handler(newVal, oldVal) {
        //如果只剩一家询价酒店展示业务人员
        if(newVal.length==1){
            this.showBusiness=true;
        }
        //如果全部询价酒店转换为群发询价
        if(newVal.length==0){
            this.$emit('judgmentInquiry');
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    //更新酒店询价信息
    ...mapMutations(['UPDATEINQUIRYLISTINFO']),
    ...mapActions(['PostGetHotelUserList']),
    //删除预订酒店
    deleteHotel(item){
        this.UPDATEINQUIRYLISTINFO({infoList:item,modify:'deletes'});
        this.$message.success('删除成功！')
    },
    //获取酒店人员列表
   async turnOnChoice(id){
        let data={store_id:id}
        let res = await this.PostGetHotelUserList(data);
        //如果是酒店发布确认单
        if(this.storeInfo.type==3){
          res.list=res.list.filter(item=>item.uid==this.userLoginMessage.uid);
          this.selectPerson(res.list[0]);
        }
        this.PersonnelList=res.list;
    },
    //改变通知全部
    async changeNotifyAll(e,orderConfirm){
        //获取业务人员
        if(e==2&&this.PersonnelList.length==0){
            let id=this.orderConfirm?this.confirmid:this.inquiryList[0].id
            await this.turnOnChoice(id);
        }else{
        //全部时·清空指定人员数组
            this.appoint_uid=[];
            this.$emit('updateAppointUid',this.appoint_uid);                     
        }
        this.notifyAll=e;
        if(orderConfirm){
            //如果是酒店发布确认单
            if(this.storeInfo.type==3){
                return;
            }
            this.confirmVisible=true;
        }
    },
    //点击添加人员
    selectPerson(item){
        //确认单变为单选
        if(this.orderConfirm){this.appoint_uid=[]};

        if(this.hasObjectExactMatch(this.appoint_uid,item)){
            this.appoint_uid.splice(this.appoint_uid.indexOf(item),1);
        }else{
            this.appoint_uid.push(item);
        }
        this.$emit('updateAppointUid',this.appoint_uid); 
    },
    // 简单对象的完全匹配
    hasObjectExactMatch(arr, targetObj) {
        // 将对象转为字符串进行比较
        const targetStr = JSON.stringify(targetObj);
        return arr.some(item => JSON.stringify(item) === targetStr);
    }
  }
};
</script>

<style lang="scss" scoped>
    //询价酒店
    .hotel{
        width: 280px;
        margin-left: 20px;
        margin-top: 40px;
    }
    .hotel-nrk{
        width: 96%;
        padding: 2%;
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        text-align: center;
        border-radius: 6px;
    }
    .hotel-title-text{
        line-height: 70px;
        font-weight: bold;
        font-size: 16px;
        text-align: center;
    }
    .hotel-item{
    text-align: left;
    width: 90%;
    padding:3%;
    margin: 0 auto;
    background-color: var(--smtc-color-back);
    border-radius: 4px;
    margin-bottom : 10px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    }
    .hotel-item-star{
    margin-top: 4px;
    color: var(--smtc-color-text-shallow);
    font-size: 12px;
    }
    .joinTheinquiry{
        position: absolute;
        right: 0px;
        bottom: 0px;
        background-color: var(--smtc-color-text-red);
        width: 30px;
        height: 30px;
        color: #fff;
        clip-path: polygon(100% 0, 100% 100%, 0 100%);  
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .joinTheinquiry .cross{
        margin-top: 12px;
        margin-left: 10px;
        font-size: 12px;
        transform: rotate(45deg);
    }
    .hotel-item-list{
        max-height: 840px;
        overflow: auto;
    }
    .business{
        width: 96%;
        margin: 0 auto;
        text-align: left;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .business-list{
        // border: 1px solid var();
       
        text-align: left;
        width: 96%;
        margin: 0 auto;
        
        border-radius: 4px;
        line-height: 28px;
        font-size: 12px;
        li{
            display: flex;
            padding: 2%  4%;
            background-color: var(--smtc-color-back);
            margin-bottom: 12px;
            border-radius: 4px;
            cursor: pointer;
        }
        i{
            display: inline-block;
        }
    }
    .personnel{
        margin-left: auto;
    }
    .room-Type{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        width: 94%;
        padding: 3%;
        border-radius: 6px;
    }
</style>
